<template>
    <div class="strategy_main" v-if="bigCat5Strategy != null">
        <img :src="geneNetworkPicture(bigCat5Strategy.background.backgroundPicture)" class="big_cat_blur_backgroud"/>
        <div id="navigation_title" v-if="!isWeixinBrowser()" class="navigation" :style="{height:getNavCount()+'px'}">
            <div :style="{height:getStateHeight()+'px'}"></div>
            <div class="left" @click="goBack"><i class="icon-thin_back"/></div>
            <div class="title">视频讲解</div>
            <div class="clear"></div>
        </div>

        <div v-if="!isWeixinBrowser()" :style="{'padding-top':getNavCount()+'px'}"></div>

        <!-- 讲解视频 -->
        <div class='video_content'>
            <video-player class="video-player vjs-custom-skin"
                          ref="videoPlayer"
                          :playsinline="true"
                          :options="playerOptions">
            </video-player>
        </div>

        <!-- 讲解知识点 -->
        <div class="knowledge_title">
            第{{bigCat5Strategy.lessonNo}}课 {{bigCat5Strategy.englishName}}视频讲解
        </div>
        <div class="knowledge_content">
            {{bigCat5Strategy.knowledgePoint}}
        </div>

        <div class="gold_split"></div>

        <!-- 本课故事结构 -->
        <div class="structure_title">
            课程结构图  <span>长按可以保存图片</span>
        </div>

        <div class="strategy_picture">
            <div class="group_img" v-for="(item,index) in bigCat5Strategy.structurePicture" :key="index">
                <!-- 放大图片 -->
                <img :src="$qiNiuDomainBase + item.fileName" preview="1" />
            </div>
        </div>

        <div class="bottom"></div>

    </div>
</template>

<script>
    import { videoPlayer } from 'vue-video-player'
    import 'vue-video-player/src/custom-theme.css'
    import 'video.js/dist/video-js.css'

    export default {
        components: {
            videoPlayer
        },
        data() {
            return {
                lessonId: 0,
                bigCat5Strategy: null,
                showImg: false,
                imgSrc: '',
                playerOptions: {
                    //播放速度
                    playbackRates: [0.5, 1.0, 1.5, 2.0],
                    //如果true,浏览器准备好时开始回放。
                    autoplay: true,
                    // 默认情况下将会消除任何音频。
                    muted: false,
                    // 导致视频一结束就重新开始。
                    loop: false,
                    // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    preload: 'auto',
                    language: 'zh-CN',
                    // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    aspectRatio: '16:9',
                    // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    fluid: true,
                    sources: [{
                        //类型
                        type: "video/mp4",
                        //url地址
                        src: ''
                    }],
                    //你的封面地址
                    poster: '',
                    //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    notSupportedMessage: '此视频暂无法播放，请稍后再试',
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        //全屏按钮
                        fullscreenToggle: true
                    }
                }
            }
        },
        methods: {
            getStateHeight: function () {
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
        },
        beforeCreate() {
            let vLessonId = parseInt(this.$route.query.lessonId);
            let url = "bigCat/getBigCat5Strategy/" + vLessonId;
            let that = this;
            this.$axios.get(url).then((response) => {
                that.lessonId = vLessonId;
                that.bigCat5Strategy = response.data;

                let vedioUrl = that.$qiNiuDomainBase + that.bigCat5Strategy.video;
                that.playerOptions.poster = vedioUrl + "?vframe/jpg/offset/5";
                that.playerOptions.sources[0].src = vedioUrl;

                if (!that.isWeixinBrowser()) {
                    that.$nextTick(() => {
                        $(window).scroll(function () {
                            var scrollTop = parseFloat(parseFloat($(window).scrollTop()));

                            if (scrollTop > 44) {
                                $("#navigation_title").removeClass("navigation");
                                $("#navigation_title").addClass("navigation_white");
                            } else {
                                $("#navigation_title").removeClass("navigation_white");
                                $("#navigation_title").addClass("navigation");
                            }
                        });
                    });
                }
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        activated() {
            window.scrollTo(0, 0);
        }
    }
</script>

<style scoped>

    .strategy_main {
        position: absolute;
        width: 100%;
        height: auto;
        min-height: 100%;
        text-align: center;
    }

    .video_content {
        display: inline-block;
        width: 100%;
        height: auto;
        text-align: center;
        line-height: 100px;
        /*border: 1px solid transparent;*/
        /*border-radius: 4px;*/
        overflow: hidden;
        background: #fff;
        position: relative;
        /*box-shadow: 0 1px 1px rgba(0, 0, 0, .2);*/
    }

    .knowledge_title {
        width: 100%;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        color: white;
        padding-left: 15px;
        padding-right: 15px;
        margin-top: 20px;
    }

    .knowledge_content {
        width: 100%;
        font-size: 17px;
        text-align: left;
        color: white;
        padding-left: 15px;
        padding-right: 15px;
        margin-top: 10px;
    }

    .gold_split {
        width: 100%;
        height: 10px;
        background-color: rgba(255, 176, 0, 0.7);
        margin-top: 30px;
        margin-bottom: 30px;
    }

    .structure_title {
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        line-height: 30px;
        color: white;
        padding-left: 15px;
        padding-right: 15px;
        margin-bottom: 10px;
    }

    .structure_title span {
        font-size: 15px;
        color: white;
        line-height: 30px;
        vertical-align: middle;
    }

    .video_content:hover {
        display: block;
    }

    .strategy_picture {
        position: relative;
        width: calc(100% - 15px);
        z-index: 997;
        display: flex;
        flex-wrap: wrap;
    }

    .group_img {
        width: calc((100% - 30px)/2);
        height: auto;
        margin-left: 15px;
        margin-top: 10px;
        z-index: 997;
    }

    .group_img img {
        width: 100%;
        height: auto;
        background-color: white;
    }

    .group_img .text {
        width: 100%;
        font-size: 13px;
        margin-top: 10px;
        color: white;
        text-align: center;
    }

    .bottom {
        height: 100px;
    }

</style>